import { useState } from 'react';

import { Comma, formatNumberWithCurrency, TComma } from '../../../../base/utils';
import walletStyles from '../Wallet.module.css';
import { ReactComponent as Minus } from './../../../../assets/svg/minus.svg';
import { ReactComponent as Plus } from './../../../../assets/svg/plus.svg';
import styles from './CashCredit.module.css';

export const CashCredit = ({
  currentCredit,
  credits,
  postChargeWallet,
  maxAmount,
  minAmount,
  addStep,
  reduceStep
}) => {
  const [amount, setAmount] = useState('');

  const onChangeCreditHandler = (credit) => {
    if (amount === '') setAmount(credit);
    else if (parseInt(amount, 10) <= maxAmount) {
      setAmount(credit);
    }
  };

  const addAmount = () => {
    if (amount === '') setAmount(addStep / 10);
    else if (parseInt(amount, 10) < maxAmount) {
      setAmount(parseInt(amount, 10) + addStep / 10);
    }
  };

  const reduceAmount = () => {
    if (parseInt(amount, 10) > minAmount) {
      setAmount(parseInt(amount, 10) - reduceStep / 10);
    }
  };

  const submitCredit = () => {
    setAmount(parseInt(amount, 10));
    postChargeWallet(amount * 10);
  };

  //   const handleInputValue = (event) => {
  //     const value = event.target.value.replace(/,/g, "");
  //     if (value) {
  //       if (value > maxAmount) {
  //         setAmount(maxAmount);
  //       } else setAmount(value);
  //     }
  //   };

  const handleInputValue = (event) => {
    const value = event.target.value.replace(/,/g, '');
    if (value) {
      if (value > maxAmount) {
        setAmount(maxAmount);
      } else {
        setAmount(value);
      }
    } else {
      setAmount('');
    }
  };

  // const onBlurInputValue = (event) => {
  //     if (event.target.value.replace(/,/g, '') < minAmount) {
  //         setAmount(minAmount)
  //     }
  // }

  return (
    <div className={walletStyles.WalletSection}>
      <div className={walletStyles.CurrentCreditWrapper}>
        <div>اعتبار فعلی:</div>
        <div className="CurrentCreditValue">{formatNumberWithCurrency(currentCredit)}</div>
      </div>
      <div className={styles.Credits}>
        {credits.map((credit, i) => (
          <button
            key={i}
            className={styles.CreditBtn}
            onClick={() => onChangeCreditHandler(credit / 10)}
            type="button">
            {TComma(credit)} تومان
          </button>
        ))}
      </div>
      <div className={styles.CashCreditInputWrapper}>
        <button onClick={addAmount} type="button">
          <Plus />
        </button>
        <input
          className={styles.CashCreditInput}
          max={maxAmount}
          maxLength={maxAmount.length}
          min={minAmount}
          onChange={handleInputValue}
          placeholder="مبلغ خود را وارد کنید"
          type="string"
          value={amount ? Comma(amount) : amount}
          // onBlur={onBlurInputValue}
        />
        <div style={{ position: 'absolute', left: '20%' }}>تومان</div>
        <button onClick={reduceAmount} type="button">
          <Minus />
        </button>
      </div>
      <div className="flex-i center-content">
        <button className={walletStyles.SubmitBtn} onClick={submitCredit} type="button">
          پرداخت
        </button>
      </div>
    </div>
  );
};
